<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table :loading="gettingTests" :pagination.sync="testHistoryPagination" :items="tests" :headers="[{ text: 'Test Date', value: 'time' }, { text: 'Last Update', value: 'formattedLastUpdate' }, { text: 'Name', value: 'tester' }]">
          <template v-slot:items="props">
            <tr @click="setActiveTest(props.item)">
              <td :class="props.item.UID === activeTest ? 'info' : ''">{{props.item.date}}</td>
              <td :class="props.item.UID === activeTest ? 'info' : ''">{{props.item.formattedLastUpdate}}</td>
              <td :class="props.item.UID === activeTest ? 'info' : ''">{{props.item.tester}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs4>
        <v-select
          label="ID type"
          v-model="IDType"
          return-object
          :items="IDSelections"
          item-text="name"
          dense
        />
      </v-flex>
      <v-flex xs8>
        <v-text-field
          type="number"
          :label="IDType.name"
          v-model="ID"
          dense
        />
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <v-btn
          color="primary"
          @click="testDevice"
          :loading="gettingResults"
          :disabled="ID.length < 5"
        >
          TEST NOW
        </v-btn>
      </v-flex>
      <v-alert :value="error.length > 0" type="error">{{error}}</v-alert>
      <v-flex xs12 v-if="results.LastUpdate">
        <v-flex xs12>
          <p>Check connected in the last from check date.</p>
          <v-select
            ref="connectedSince"
            label="Custom"
            :items="connectedSinceItems"
            v-model="connectedSince"
            class="mb-0 pb-0"
            :hint="selectionHint"
            persistent-hint
            solo
            prepend-icon="mdi-calendar"
            @click:prepend="dateModal = true"
            @change="selectionHint = ''"
          />
          <v-dialog
            ref="dialog"
            v-model="dateModal"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-card>
              <v-date-picker v-model="date" scrollable no-title style="box-shadow: none;"/>
              <v-text-field
                label="Time"
                v-model="time"
                type="time"
                mask="time"
                outline
                class="mx-5"
              ></v-text-field>
              <v-btn flat color="primary" @click="dateModal = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="setCustomDate">OK</v-btn>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-layout row wrap>
          <v-flex md3>
            <h3 class="subheading grey--text">Vehicle Section</h3>
            <table>
              <tbody>
                <tr>
                  <th>Date</th>
                  <td><v-icon large :color="compareDate(results.LastUpdate) ? 'success' : 'error'" v-html="compareDate(results.LastUpdate) ? 'check' : 'close'" />{{results.LastUpdate|formatDate}}</td>
                </tr>
                <tr>
                  <th>Reg</th>
                  <td>{{results.Registration}}</td>
                </tr>
                <tr>
                  <th>Friendly Name</th>
                  <td>{{results.FriendlyName}}</td>
                </tr>
                <tr>
                  <th>Vehicle Group</th>
                  <td>{{results.VehicleGroup}}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td v-html="results.Address"></td>
                </tr>
                <tr>
                  <th>Vehicle State</th>
                  <td>{{results.VehicleState}}</td>
                </tr>
                <tr>
                  <th>GPS Fix</th>
                  <td><v-icon large :color="results.GPSFix > 5 ? 'success' : 'error'" v-html="results.GPSFix > 5 ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>Ignition On</th>
                  <td><v-icon large :color="compareDate(results.IgnitionOn) ? 'success' : 'error'" v-html="compareDate(results.IgnitionOn) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>Ignition Off</th>
                  <td><v-icon large :color="compareDate(results.IgnitionOff) ? 'success' : 'error'" v-html="compareDate(results.IgnitionOff) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>IMEI</th>
                  <td>{{results.IMEI}}</td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex md3>
            <h3 class="subheading grey--text">CAN Section</h3>
            <table>
              <tbody>
                <tr>
                  <th>SQ EON</th>
                  <td><v-icon large :color="compareDate(results.SQEon) ? 'success' : 'error'" v-html="compareDate(results.SQEon) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>SQ EOFF</th>
                  <td><v-icon large :color="compareDate(results.SQEoff) ? 'success' : 'error'" v-html="compareDate(results.SQEoff) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                <th>SQ D8</th>
                  <td><v-icon large :color="compareDate(results.SQTacho) ? 'success' : 'error'" v-html="compareDate(results.SQTacho) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>SQ 1 Minute</th>
                  <td><v-icon large :color="compareDate(results.SQ30sNIBC) ? 'success' : 'error'" v-html="compareDate(results.SQ30sNIBC) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>Odometer</th>
                  <td>{{results.Odometer}}</td>
                </tr>
                <tr>
                  <th>Fuel</th>
                  <td>
                    <span v-if="results.FuelLevel">{{results.FuelLevel}}</span>
                    <v-icon v-else large color="error" v-html="'close'" />
                  </td> 
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex md3>
            <h3 class="subheading grey--text">Tacho Section</h3>
            <table>
              <tbody>
                <tr>
                  <th>Driver Name</th>
                  <td>{{results.TachoSysDriverName}}</td>
                </tr>
                <tr>
                  <th>DDS Message Updated</th>
                  <td><v-icon large :color="compareDate(results.TachoSysMessageUpdated) ? 'success' : 'error'" v-html="compareDate(results.TachoSysMessageUpdated) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>TachoSys Card Number</th>
                  <td>{{results.TachoSysCardNumber}}</td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex md3>
            <h3 class="subheading grey--text">DVR Section</h3>
            <table>
              <tbody>
                <tr>
                  <th>DVR ID</th>
                  <td>{{results.DVRID}}</td>
                </tr>
                <tr>
                  <th>ACC Ignition On</th>
                  <td><v-icon large :color="compareDate(results.ACCIgnitionOnDateTime) ? 'success' : 'error'" v-html="compareDate(results.ACCIgnitionOnDateTime) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>Device Online</th>
                  <td><v-icon large :color="compareDate(results.DeviceOnlineDateTime) ? 'success' : 'error'" v-html="compareDate(results.DeviceOnlineDateTime) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>GSM Dial Up OK</th>
                  <td><v-icon large :color="compareDate(results.GSMDialUpOKDateTime) ? 'success' : 'error'" v-html="compareDate(results.GSMDialUpOKDateTime) ? 'check' : 'close'" /></td>
                </tr>
                <tr>
                  <th>HDD Write OK</th>
                  <td><v-icon large :color="compareDate(results.HDDWriteOKDateTime) ? 'success' : 'error'" v-html="compareDate(results.HDDWriteOKDateTime) ? 'check' : 'close'" /></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn color="primary" @click="notesDialog=true">Additional information</v-btn>
        </div>
        <div class="text-xs-center" v-if="results.ICCID">
          <v-autocomplete
            label="Select Test Message"
            :items="messageTemplates"
            v-model="message"
          />
          <v-btn color="primary" :disabled="message.length < 1" @click="sendMessage" :loading="sendingMessage">Send Message</v-btn>
        </div>
        <v-dialog v-model="notesDialog">
          <v-card class="pa-2">
            <v-card-title>Use this to record any notes/images against this test.</v-card-title>
            <v-divider />
            <v-textarea
              label="Notes"
              v-model="extraNotes"
            />
            <v-list>
              <v-list-tile v-for="(file, i) in uploadedFiles" :key="i">
                <v-list-tile-content>
                  <v-list-tile-title><a target="_blank" :href="file.downloadUrl">{{file.name}}</a></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list>
              <v-list-tile v-for="(file, i) in fileList" :key="i">
                <v-list-tile-action>
                  <v-icon color="error" @click="fileList.splice(i, 1)">delete</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{file.name}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-btn @click="$refs.fileInput.click()">Add File(s)</v-btn>
            <input ref="fileInput" hidden multiple type="file" @change="addFiles"/>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="notesDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" :loading="savingNotes" @click="saveExtraDetails">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="notesSaved"
      color="success"
      :timeout="2000"
    >
      Details Saved
      <v-btn
        flat
        @click="notesSaved = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from 'moment'
import { fireStore, storage } from '../firebase'
export default {
  props: ['testID', 'testType', 'UID', 'activeTestUID'],
  watch: {
    testType (val) {
      if (val === 'IMEI') {
        this.IDType = {
          name: 'IMEI',
          type: 'IMEI'
        }
      } else {
        this.IDType = {
          name: 'DVR ID',
          type: 'DVRID'
        }
      }
    },
    testID (val) {
      this.ID = val
    },
    UID (val) {
      if (val) {
        console.log(val)
        this._UID = val
        this.getTestHistory()
      }
    }
  },
  data () {
    return {
      _UID: null,
      testHistoryPagination: {
        sortBy: 'time',
        rowsPerPage: 5,
        page: 1,
        descending: true
      },
      activeTest: null,
      ID: '',
      error: '',
      date: moment().format('YYYY-MM-DD'),
      selectionHint: '',
      extraNotes: '',
      time: '00:00',
      results: {},
      fileList: [],
      IDSelections: [
        {name: 'IMEI', type: 'IMEI'},
        {name: 'DVR ID', type: 'DVRID'}
      ],
      IDType: {
        name: 'IMEI',
        type: 'IMEI'
      },
      messageTemplates: [
        {text: 'DVR On (Out 1 Clear)', value: '!R3,9,1'},
        {text: 'DVR Off (Out 1 Set)', value: '!R3,8,1'},
        {text: 'Side Scan Mute On (Out 0 Clear)', value: '!R3,9,0'},
        {text: 'Side Scan Mute Off (Out 0 Set)', value: '!R3,8,0'},
        {text: 'DAP Panel On (Out 2 Clear)', value: '!R3,9,2'},
        {text: 'DAP Panel Off (Out 2 Set)', value: '!R3,8,2'}
      ],
      message: '',
      sendingMessage: false,
      dateModal: false,
      gettingResults: false,
      connectedSince: 30,
      notesSaved: false,
      connectedSinceItems: [
        {text: '30 minutes', value: 30},
        {text: '1 hour', value: 60},
        {text: '6 hours', value: 360},
        {text: '24 hours', value: 1440}
      ],
      notesDialog: false,
      savingNotes: false,
      tests: [],
      uploadedFiles: [],
      gettingTests: false,
      messageSent: false
    }
  },
  methods: {
    sendMessage () {
      this.sendingMessage = true
      let messageData = []
      messageData.push({
        messageType: 1,
        ICCID: this.results.ICCID,
        message: btoa(this.message)
      })
      fireStore.collection('SIMmessages').add({
        messages: messageData,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.userData.Name
      }).then((val) => {
        this.sendingMessage = false
        this.messageSent = true
      }).catch((error) => {
        this.sendingMessage = false
        alert('Unexpected Error Occured')
        console.log(error)
      })
    },
    setActiveTest (props) {
      this.activeTest = props.UID
      this.results = props
      this.extraNotes = props.notes || ''
      this.uploadedFiles = props.files || []
      if (props.IMEI) {
        this.ID = props.IMEI
        this.IDType = {
          name: 'IMEI',
          type: 'IMEI'
        }
      } else {
        this.ID = props.DVRID
        this.IDType = {
          name: 'DVR ID',
          type: 'DVRID'
        }
      }
    },
    getTestHistory () {
      this.tests = []
      this.gettingTests = true
      fireStore.collection('Devices').doc(this._UID).collection('tests').get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.UID = doc.id
            data.tester = data.user ? (data.user.name || data.user.email) : 'Anonymous'
            data.date = moment(data.time).format('DD/MM/YYYY HH:mm')
            data.formattedLastUpdate = moment(data.LastUpdate, 'YYYYMMDDHHmm').format('DD/MM/YYYY HH:mm')
            this.tests.push(data)
            if (this.activeTestUID === data.UID) {
              this.setActiveTest(data)
            }
          })
          this.gettingTests = false
        })
    },
    saveExtraDetails () {
      let promises = []
      let downloadUrls = []
      this.savingNotes = true
      const storageRef = storage.ref(`DeviceTests/${this.activeTest}`)
      for (let file of this.fileList) {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(file.name).put(file)
          uploadTask.on('state_changed', snapshot => {}, error => {
            reject(error)
          }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              downloadUrls.push({downloadUrl: downloadURL, name: file.name})
              resolve()
            })
          })
        })
        )
      }
      Promise.all(promises).then(val => {
        downloadUrls = downloadUrls.concat(this.uploadedFiles)
        console.log({ notes: this.extraNotes, files: downloadUrls })
        fireStore.collection('Devices').doc(this.results.SerialNumber)
                  .collection('tests').doc(this.activeTest).set({
                    notes: this.extraNotes,
                    files: downloadUrls
                  }, {merge: true})
        .then(docRef => {
          this.notesSaved = true
          this.savingNotes = false
          this.notesDialog = false
          this.uploadedFiles = downloadUrls
          this.fileList = []
          this.getTestHistory()
        })
        .catch(error => {
          this.savingNotes = false
          alert('Something went wrong :(. Try saving again.')
          console.log(error)
        })
      }).catch(error => {
        this.savingNotes = false
        alert('Something went wrong :(. Try saving again.')
        console.log(error)
      })
    },
    testDevice () {
      this.error = ''
      let toSend = {
        ID: this.ID,
        user: {
          name: this.$store.getters.userData.Name,
          email: this.$store.getters.userData.Email
        },
        IDType: this.IDType.type
      }
      this.gettingResults = true
      let url = `https://us-central1-engineer-ae17e.cloudfunctions.net/runDeviceTest`
      fetch(url,
        {
          headers: {'content-type': 'application/json; charset=UTF-8'},
          method: 'POST',
          body: JSON.stringify(toSend)
        },
        {mode: 'cors'}
      )
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (data.error) {
            this.error = data.error
            this.results = []
            this.gettingResults = false
            this.extraNotes = ''
            this.fileList = []
            this.$emit('testId', -1)
            return
          }
          this._UID = data.SerialNumber
          this.activeTest = data.testId
          this.getTestHistory()
          this.$emit('testId', `${data.SerialNumber}/tests/${data.testId}`)
          this.results = data
          this.gettingResults = false
          this.extraNotes = ''
          this.fileList = []
          this.$nextTick(() => {
            setTimeout(() => {
              this.$vuetify.goTo(this.$refs.connectedSince)
            }, 200)
          })
        })
    },
    compareDate (date) {
      return moment(this.results.time).diff(moment(date, 'YYYYMMDDHHmmss'), 'minutes') < this.connectedSince
    },
    setCustomDate () {
      this.dateModal = false
      this.selectionHint = 'Since: ' + moment(this.date + ' ' + this.time).format('DD/MM/YYYY HH:mm')
      this.connectedSince = moment().diff(moment(this.date + ' ' + this.time), 'minutes')
    },
    addFiles (e) {
      for (let file of e.target.files) {
        this.fileList.push(file)
      }
      this.$refs.value = ''
    }
  },
  filters: {
    formatDate (val) {
      return moment(val, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style scoped>
  th {
    text-align: left;
    padding-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// Testing.vue?e675a2ba